// FieldText Component

import FieldText from '../field_text/field_text.jsx'

class FieldNumber extends FieldText {
  _isTypeNumber () {
    return true
  }
}

export default FieldNumber
